import { useConst } from "@chakra-ui/react";
import { AsyncReturnType } from "type-fest";

import { CampaignService } from "@/services/campaign-service";
import { UseQuerySimpleOptions, useQuery } from "@/services/hooks/use-query";
import { gen } from "@/utils";

type QueryArgs = Parameters<typeof CampaignService.get>[0];
type QueryFnData = AsyncReturnType<typeof CampaignService.get>;
type Error = unknown;

const queryKey = ({ id }: QueryArgs) => ["campaigns", id];

export const useCampaign = <TData = QueryFnData>(
  args: QueryArgs,
  options?: UseQuerySimpleOptions<QueryFnData, Error, TData>
) => {
  const response = useQuery<QueryFnData, Error, TData>(
    queryKey(args),
    () => CampaignService.get(args),
    {
      skeletonData: useConst(gen.campaign()),
      ...options,
    }
  );

  return response;
};

useCampaign.queryKey = queryKey;
